<template>
  <el-dialog
      title="Chỉnh sửa cấu hình đăng nhập"
      :visible.sync="visible"
      width="600px"
      :before-close="handleClose"
      top="6vh"
      :close-on-click-modal="false"
      @open="handleOpen"
      custom-class="login-config-dialog"
  >
    <el-form
        class="login-config-form"
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="left"
        label-width="130px"
    >
      <div class="login-config-content">
        <div class="login-config-panel">
          <div class="login-config-panel-head">
            <div class="panel-icon">
              <i class="el-icon-edit"></i>
            </div>
            <div>
              <p class="panel-title">Cập nhật cấu hình hiện có</p>
              <p class="panel-subtitle">Điều chỉnh dữ liệu cấu hình và lưu lại để áp dụng cho trang đăng nhập.</p>
            </div>
          </div>

          <el-form-item label="Key" prop="configKey">
            <el-input v-model="formData.configKey" prefix-icon="el-icon-collection-tag" placeholder="Nhập key" clearable/>
          </el-form-item>

          <el-form-item label="Loại media" prop="mediaType">
            <el-select v-model="formData.mediaType" placeholder="Chọn loại media" style="width:100%">
              <el-option v-for="t in mediaTypeOptions" :key="t.value" :label="t.label" :value="t.value"/>
            </el-select>
          </el-form-item>

          <el-form-item label="Giá trị" prop="configValue">
            <el-input
                v-model="formData.configValue"
                type="textarea"
                :rows="3"
                placeholder="Nhập giá trị cấu hình"
            />
          </el-form-item>

          <el-form-item label="Nhóm" prop="groupName">
            <el-select v-model="formData.groupName" placeholder="Chọn nhóm cấu hình" style="width:100%">
              <el-option v-for="group in groupNameOptions" :key="group.value" :label="group.label" :value="group.value"/>
            </el-select>
          </el-form-item>

          <el-form-item label="Thứ tự ưu tiên" prop="orderPriority">
            <el-input-number
                v-model="formData.orderPriority"
                :min="0"
                :max="9999"
                :disabled="isOrderPriorityDisabled"
                style="width:100%"
            />
          </el-form-item>

          <el-form-item label="Trạng thái" prop="active">
            <el-switch
                v-model="formData.active"
                active-text="Hoạt động"
                inactive-text="Ngừng"
            />
          </el-form-item>

          <div class="login-config-note">
            <i class="el-icon-info"></i>
            <span>Kiểm tra lại  key, loại media và thứ tự ưu tiên trước khi cập nhật để tránh ảnh hưởng hiển thị.</span>
          </div>
        </div>
      </div>
    </el-form>

    <span slot="footer" class="dialog-footer login-config-footer">
      <el-button class="btn-cancel" type="danger" @click="handleClose">
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
      <el-button class="btn-save" :loading="loading" type="success" @click="handleSubmit">
        <i class="el-icon-circle-check"/>
        <span>Cập nhật</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import LoginConfigService from "@/services/AdminService/LoginConfigService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

const MEDIA_TYPE_OPTIONS = [
  {value: 'IMAGE', label: 'IMAGE'},
  {value: 'VIDEO', label: 'VIDEO'},
  {value: 'YOUTUBE', label: 'YOUTUBE'},
  {value: 'TEXT', label: 'TEXT'},
  {value: 'LINK', label: 'LINK'},
  {value: 'PHONE', label: 'PHONE'},
];

const GROUP_NAME_OPTIONS = [
  {value: 'DOWNLOAD_LINK', label: 'DOWNLOAD_LINK'},
  {value: 'FOOTER', label: 'FOOTER'},
  {value: 'PHONE', label: 'PHONE'},
  {value: 'SOCIAL_LINK', label: 'SOCIAL_LINK'},
  {value: 'VISUAL_SLIDER', label: 'VISUAL_SLIDER'},
];

export default {
  name: "UpdateLoginConfigDialog",
  props: {
    visible: {type: Boolean, default: false},
    item: {type: Object, default: null},
  },
  data() {
    return {
      loading: false,
      mediaTypeOptions: MEDIA_TYPE_OPTIONS,
      groupNameOptions: GROUP_NAME_OPTIONS,
      formData: {
        configKey: '',
        configValue: '',
        mediaType: '',
        groupName: '',
        orderPriority: 0,
        active: true,
      },
      rules: {
        configKey: [{required: true, message: 'Config Key không được để trống', trigger: 'blur'}],
        configValue: [{required: true, message: 'Giá trị không được để trống', trigger: 'blur'}],
        mediaType: [{required: true, message: 'Vui lòng chọn loại media', trigger: 'change'}],
        groupName: [{required: true, message: 'Vui lòng chọn nhóm', trigger: 'change'}],
        orderPriority: [{required: true, message: 'Thứ tự không được để trống', trigger: 'blur'}],
      },
    };
  },
  computed: {
    isOrderPriorityDisabled() {
      return this.formData.groupName !== 'VISUAL_SLIDER';
    },
  },
  watch: {
    'formData.groupName'(val) {
      if (val !== 'VISUAL_SLIDER') {
        this.formData.orderPriority = 0;
      }
    },
  },
  methods: {
    handleOpen() {
      if (this.item) {
        this.formData = {
          configKey: this.item.configKey || '',
          configValue: this.item.configValue || '',
          mediaType: this.item.mediaType || '',
          groupName: this.item.groupName || '',
          orderPriority: this.item.orderPriority ?? 0,
          active: this.item.active !== undefined ? this.item.active : true,
        };
      }
    },

    handleClose() {
      this.$refs['formData'].resetFields();
      this.$emit('close', false);
    },

    handleSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (!valid) return;
        this.loading = true;
        LoginConfigService.update(this.item.id, this.formData)
            .then((res) => {
              if (res.data.data) {
                NotifyMessage.leftCornerNotificationSuccess("Cập nhật cấu hình thành công");
                this.$emit('close', true);
              } else {
                NotifyMessage.leftCornerNotificationError("Cập nhật cấu hình thất bại");
              }
            })
            .catch((err) => {
              NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Lỗi kết nối");
            })
            .finally(() => {
              this.loading = false;
            });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-config-content {
  padding: 4px 0 6px;
}

.login-config-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
}

.login-config-panel-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}

.panel-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #60a5fa, #2563eb);
  color: #ffffff;
  font-size: 18px;
  flex-shrink: 0;
}

.panel-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.panel-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.login-config-note {
  margin-top: 4px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #eff6ff;
  color: #1d4ed8;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.5;
}

.login-config-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/deep/ .login-config-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .login-config-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/ .login-config-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/ .login-config-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/ .login-config-dialog .el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

/deep/ .login-config-form .el-form-item {
  margin-bottom: 16px;
}

/deep/ .login-config-form .el-form-item__label {
  color: #475569;
  font-weight: 600;
}

/deep/ .login-config-form .el-input__inner,
/deep/ .login-config-form .el-textarea__inner,
/deep/ .login-config-form .el-input-number .el-input__inner,
/deep/ .login-config-form .el-select .el-input__inner {
  border-radius: 10px;
}

/deep/ .btn-cancel,
/deep/ .btn-save {
  min-width: 110px;
  border-radius: 10px;
}
</style>

